import { useI18n } from '@/i18n/i18n-context'
import { Button } from '@/ui/button'
import { Card } from '@/ui/card'

/**
 * The end of the reload budget (docs/decisions.md D-46): a stage that has stalled twice already and
 * stalled again.
 *
 * Not {@link ScanFailedScreen}, whose title says the scan could not be completed - no scan has been
 * attempted at this point, and telling a patient their scan failed when nothing has measured
 * anything sends them to a support line with the wrong story.
 */
export function CouldNotLoadScreen({ onRetry }: { onRetry: () => void }) {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-3 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('pageCouldNotLoad')}</h1>
      <Button onClick={onRetry}>{t('tryAgain')}</Button>
    </Card>
  )
}
